const initialValue = {
    data: [],
    error: "",
  };
  
  const mySubscriptionReducer = (state = initialValue, action) => {
    switch (action.type) {
      case "GET_MY_SUBSCRIPTION_SUCCESS":
        return {
          ...state,
          data: action.payload,
          error: "",
        };
      case "GET_MY_SUBSCRIPTION_FAILURE":
        return {
          ...state,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default mySubscriptionReducer;
  